
export interface ScatterData {
	x: number
	y: number
	index: number
	color: string
}
export enum CHART_ZOOM_TYPES {
	XY = "BOTH DIMENSIONS",
	X = "X-AXIS ONLY",
	Y = "Y-AXIS ONLY"
}
